export default __webpack_public_path__ + "fonts/national-dnc.svg";